import { LogLevels } from "@app/_models/log-levels";
import { baseEnvironment, devAuth0 } from './environment.base';

export const environment = {
    ...baseEnvironment,
    ...devAuth0,
    production: false,
    apiUrl: 'https://delivery.lido.ph/api/',
    logoutUrl: 'https://delivery.lido.ph',
    loginRedirectUrl: 'https://delivery.lido.ph',
    paymongoReturnUrl: 'https://delivery.lido.ph/checkout/paymongo-resume',
    googleMapsApiKey: 'AIzaSyBQCgHhi0NcxSfIlSC89_zN-gljh2l0u_o',
    logLevel: 'debug' as LogLevels,
};
